import { apiGetTpl_appBy_first_category, RespTplApp } from '@vas2t-lowcode/api';
import type { AxiosPromise } from 'axios';

let appListReq = undefined as undefined | AxiosPromise<RespTplApp[]>;

/**
 * 获取预加载的数据
 *
 * @returns
 */
export const reqDefAppListDataAsync = () => {
  if (!appListReq) {
    appListReq = window._reqTemplateAppListAsync || apiGetTpl_appBy_first_category();
    return appListReq;
  }

  return appListReq;
};

/**
 * 重置预加载的数据, 防止下次reqBannerTopDataAsync获取的为旧数据
 *
 * @returns
 */
export const resetAppListDataAsync = () => {
  appListReq = undefined;
  window._reqTemplateAppListAsync = undefined;
};
